'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _oembed = require('../lib/oembed');

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _inputField = require('../input-field');

var _inputField2 = _interopRequireDefault(_inputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputVideo = function (_React$Component) {
  _inherits(InputVideo, _React$Component);

  function InputVideo(props) {
    _classCallCheck(this, InputVideo);

    var _this = _possibleConstructorReturn(this, (InputVideo.__proto__ || Object.getPrototypeOf(InputVideo)).call(this, props));

    _this.handleClear = _this.handleClear.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      video: props.value,
      status: 'empty'
    };
    return _this;
  }

  _createClass(InputVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleChange(this.props.value);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(val) {
      var _this2 = this;

      if (!val) {
        this.setState({ status: 'empty', video: null });
        return this.props.onChange('');
      }

      Promise.resolve().then(function () {
        return _this2.setState({ status: 'fetching' });
      }).then(function () {
        return (0, _oembed.fetchOembedUrl)(val);
      }).then(function (video) {
        if (video.type !== 'video' || !_oembed.videoRegex.test(video.url)) {
          return _this2.setState({ status: 'failed' });
        }

        _this2.setState({ video: video, status: 'fetched' });
        _this2.props.onVideoChange && _this2.props.onVideoChange(video);
      }).catch(function () {
        return _this2.setState({ status: 'failed' });
      });

      this.props.onChange(val);
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      this.setState({ status: 'empty', video: null });
      this.props.onChange('');
      this.input.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          video = _state.video,
          status = _state.status;

      var _props = this.props,
          classNames = _props.classNames,
          note = _props.note,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onVideoChange = _props.onVideoChange,
          _props$styles = _props.styles,
          styles = _props$styles === undefined ? {} : _props$styles,
          value = _props.value,
          _props$type = _props.type,
          type = _props$type === undefined ? 'search' : _props$type,
          props = _objectWithoutProperties(_props, ['classNames', 'note', 'onBlur', 'onChange', 'onVideoChange', 'styles', 'value', 'type']);

      return _react2.default.createElement(
        'div',
        { className: classNames.root },
        _react2.default.createElement(_inputField2.default, _extends({}, props, {
          setRef: function setRef(ref) {
            _this3.input = ref;
          },
          type: type,
          onChange: this.handleChange,
          value: value,
          status: status,
          styles: styles.input
        })),
        video ? _react2.default.createElement(
          'div',
          { className: classNames.video },
          video.html && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: video.html } }),
          _react2.default.createElement(
            'button',
            { className: classNames.clear, onClick: this.handleClear },
            'Clear Video'
          )
        ) : _react2.default.createElement(
          'div',
          null,
          note && _react2.default.createElement(
            'small',
            { className: classNames.note },
            note
          )
        )
      );
    }
  }]);

  return InputVideo;
}(_react2.default.Component);

InputVideo.propTypes = {
  /**
   * The label for the field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * The name of the field
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * The change handler that will receive the updated value as it's only param
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The change handler that will receive the updated video information
   */
  onVideoChange: _propTypes2.default.func,

  /**
   * Mark the field as required and displays an asterisk next to the label
   */
  required: _propTypes2.default.bool,

  /**
   * A note to show under the button
   */
  note: _propTypes2.default.string
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputVideo);